import { render, staticRenderFns } from "./ResultComp.vue?vue&type=template&id=a4871b10&"
import script from "./ResultComp.vue?vue&type=script&lang=js&"
export * from "./ResultComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports